import type { RouteRecordName, RouteRecordRaw, RouteRecordRedirectOption } from 'vue-router';

import { PlatformLayout } from '@/widgets/platform-layout';

const PlatformOverviewPage = () =>
  import('@/pages/platform-overview').then((m) => ({ default: m.PlatformOverviewPage }));
const PlatformOrganizationsPage = () =>
  import('@/pages/platform-organizations').then((m) => ({ default: m.PlatformOrganizationsPage }));
const PlatformAccessDeniedPage = () =>
  import('@/pages/platform-access-denied').then((m) => ({ default: m.PlatformAccessDeniedPage }));
const PlatformOrganizationPage = () =>
  import('@/pages/platform-organization').then((m) => ({ default: m.PlatformOrganizationPage }));
const PlatformUserPage = () => import('@/pages/platform-user').then((m) => ({ default: m.PlatformUserPage }));
const PlatformUsersPage = () => import('@/pages/platform-users').then((m) => ({ default: m.PlatformUsersPage }));
const PlatformAuditPage = () => import('@/pages/platform-audit').then((m) => ({ default: m.PlatformAuditPage }));

const platformRouteMeta = {
  requiresAuth: true,
  requiresOrganization: false,
  superuser: true,
} as const;
const createLegacyPlatformRedirect =
  (name: RouteRecordName): RouteRecordRedirectOption =>
  (to) => ({
    name,
    params: to.params,
    query: to.query,
    hash: to.hash,
  });

export const platformRoutes: RouteRecordRaw[] = [
  {
    path: '/access-denied',
    name: 'auth.platform-access-denied',
    component: PlatformAccessDeniedPage,
    meta: {
      sidebar: false,
      requiresAuth: true,
      requiresOrganization: false,
    },
  },

  // Redirects keep existing bookmarks valid after removing the redundant
  // /platform prefix from the dedicated platform host.
  {
    path: '/platform',
    redirect: createLegacyPlatformRedirect('platform.overview'),
  },
  {
    path: '/platform/access-denied',
    redirect: createLegacyPlatformRedirect('auth.platform-access-denied'),
  },
  {
    path: '/platform/organizations',
    redirect: createLegacyPlatformRedirect('platform.organizations'),
  },
  {
    path: '/platform/organizations/:id',
    redirect: createLegacyPlatformRedirect('platform.organizations.show'),
  },
  {
    path: '/platform/users',
    redirect: createLegacyPlatformRedirect('platform.users'),
  },
  {
    path: '/platform/users/:id',
    redirect: createLegacyPlatformRedirect('platform.users.show'),
  },
  {
    path: '/platform/audit',
    redirect: createLegacyPlatformRedirect('platform.audit'),
  },

  // Platform console
  // meta задаётся только на родителе: vue-router сливает meta всех совпавших
  // записей, поэтому guard-ы видят platformRouteMeta и на дочерних маршрутах.
  {
    path: '/overview',
    component: PlatformLayout,
    meta: platformRouteMeta,
    children: [
      {
        path: '',
        name: 'platform.overview',
        component: PlatformOverviewPage,
      },
    ],
  },
  {
    path: '/organizations',
    component: PlatformLayout,
    meta: platformRouteMeta,
    children: [
      {
        path: '',
        name: 'platform.organizations',
        component: PlatformOrganizationsPage,
      },
      {
        path: ':id',
        name: 'platform.organizations.show',
        component: PlatformOrganizationPage,
      },
    ],
  },
  {
    path: '/users',
    component: PlatformLayout,
    meta: platformRouteMeta,
    children: [
      {
        path: '',
        name: 'platform.users',
        component: PlatformUsersPage,
      },
      {
        path: ':id',
        name: 'platform.users.show',
        component: PlatformUserPage,
      },
    ],
  },
  {
    path: '/audit',
    component: PlatformLayout,
    meta: platformRouteMeta,
    children: [
      {
        path: '',
        name: 'platform.audit',
        component: PlatformAuditPage,
      },
    ],
  },
];
